import React, { useState, useEffect } from "react";
import Header from "./Header";
import ChatInput from "./ChatInput";
import NavBar from "./Navbar";

interface LayoutProps {
  headerProps: any;
  children: React.ReactNode;
  showChatInput: boolean;
  backgroundImage?: string;
  backgroundPosition?: string;
  footerBackground?: string;
  headerBackground?: string;
  classContentWrapper?: string;
  classGetStarted?: string;
  classProfileLayout?: string;
  classChat?: string;
  showFooter?: boolean;
  onFocusInput?: () => void;
  backgroundBlur?: boolean;
  imageGetStarted?: string;
  imgGetStartedClass?: string;
  classAppContainer?: string;
  showNavBar?: boolean;
  pageType?: "home" | "chat" | "recent" | "other";
}

const Layout: React.FC<LayoutProps> = ({
  headerProps,
  children,
  showChatInput,
  backgroundImage,
  backgroundPosition,
  footerBackground,
  headerBackground,
  classContentWrapper,
  classGetStarted,
  classProfileLayout,
  classChat,
  showFooter = true,
  onFocusInput,
  backgroundBlur,
  imageGetStarted,
  imgGetStartedClass,
  classAppContainer,
  showNavBar = true,
  pageType = "other",
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isMediumLargerScreen, setIsMediumLargerScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
      setIsMediumLargerScreen(
        window.innerWidth >= 1024 && window.innerWidth < 2559
      );
      setIsLargeScreen(window.innerWidth >= 2560);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleNavbarToggle = (isOpen: boolean) => {
    setIsNavbarOpen(isOpen);
  };

  const getBackgroundStyle = () => {
    if (pageType === "home") {
      return {
        backgroundImage: "url('/assets/images/bg_homepage.jpg')",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      };
    } else if (pageType === "chat" || pageType === "recent") {
      return {
        backgroundColor: "#000",
      };
    } else if (backgroundImage) {
      return {
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: backgroundPosition || "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      };
    } else {
      return {
        backgroundImage: "url('/assets/images/bg_homepage.jpg')",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      };
    }
  };

  return (
    <div
      className={`app-container ${classAppContainer || ""}`}
      style={{
        ...getBackgroundStyle(),
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        gap:
          pageType === "home"
            ? "208px"
            : isLargeScreen && (pageType === "chat" || pageType === "recent")
            ? "24px"
            : "0",
      }}>
      {showNavBar && !isMobile && !isTablet && (
        <div className="w-1/5 navbar-wrapper">
          <NavBar />
        </div>
      )}

      {showNavBar && (isMobile || isTablet) && (
        <NavBar onNavbarToggle={handleNavbarToggle} />
      )}

      <div
        className={`${
          showNavBar && pageType === "home" && !isMobile && !isTablet
            ? "w-4/5 pr-40"
            : "w-full"
        } ${classProfileLayout || ""} ${
          isMobile || isTablet ? "mobile-layout" : ""
        }`}
        style={{
          ...(backgroundImage
            ? {
                backgroundImage: `url(${backgroundImage})`,
                backgroundPosition: backgroundPosition || "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
              }
            : { backgroundColor: "#000" }),
          // Chat page handles its own scrolling - don't add another scrollbar here
          overflow: pageType === "chat" ? "hidden" : "auto",
          height: "100%",
        }}>
        <div
          className={`content-wrapper ${classContentWrapper || ""} ${
            classGetStarted || ""
          } ${isMobile || isTablet ? "mobile-content" : ""}`}
          style={pageType === "chat" ? {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
            paddingBottom: 0,
          } : undefined}>
          <Header {...headerProps} headerBackground={headerBackground} />
          {children}
        </div>
        <div className="lg:w-1/2">
          {imageGetStarted && !isMobile && (
            <img src={imageGetStarted} alt="" className={imgGetStartedClass} />
          )}
        </div>

        {showFooter && (!isNavbarOpen || (!isMobile && !isTablet)) && (
          <div
            className={`footer lg:mb-4 ${
              isMobile || isTablet ? "" : "fixed right-0 left-0 w-4/5"
            }`}
            style={{
              paddingLeft: !isMobile && !isTablet ? "158px" : "16px",
              paddingRight: !isMobile && !isTablet ? "160px" : "16px",
            }}>
            {showChatInput && (
              <ChatInput
                onFocusInput={onFocusInput || headerProps?.onFocusInput}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
